import { AssistantPanelMode } from "../types";

export const ASSISTANT_LABELS = {
  [AssistantPanelMode.HOME]: "Home",
  [AssistantPanelMode.AI_CHAT]: "Ask",
  [AssistantPanelMode.LEARN]: "Learn",
};
